import React from 'react';
import {ScrollView, Text, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {Code, Heading, Spacer, Spacing} from '/component/base/Storybook';

import {PremierOrderDetails} from '../PremierOrderDetails';

import {styles} from './PremierOrderDetails.styles';

storiesOf('base', module).add('PremierOrderDetails', () => (
  <ScrollView>
    <Spacing size={20}>
      <Heading level={1}>PremierOrderDetails</Heading>
      <Spacer size={16} />
      <Text>
        We use <Code>PremierOrderDetails</Code> in
        ProjectedPremierVolumeReportContent for displaying record data.
      </Text>
      <Spacer size={24} />
      <View style={styles.wrapper}>
        <PremierOrderDetails
          recordData={{
            nextScheduledPremierOrder: {
              scheduledOn: '2021-07-13',
              cv: 11,
              price: {total: 12, currencyCode: '13'},
            },
            rewards: {balance: 14, currencyCode: 14},
          }}
        />
      </View>
      <Spacer size={16} />
      <Text>
        To correctly render the component you need to pass followong props:
      </Text>
      <Spacer size={16} />
      <Code>{'<PremierOrderDetails'}</Code>
      <Code>{'  recordData={{'}</Code>
      <Code>{'    nextScheduledPremierOrder: {'}</Code>
      <Code>{'      scheduledOn'}</Code>
      <Code>{'      cv'}</Code>
      <Code>{'      price: {total, currencyCode}'}</Code>
      <Code>{'    },'}</Code>
      <Code>{'    rewards: {balance, currencyCode}'}</Code>
      <Code>{'  }}'}</Code>
      <Code>{'/>'}</Code>

      <Spacer size={16} />
    </Spacing>
  </ScrollView>
));
